module.exports = __webpack_public_path__ + "static/media/x-circle-fill.1d95e3d0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/website-bot/img/x-circle-fill.webp
// module id = 436
// module chunks = 0